import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimoniosDestacados, testimoniosExtra } from '../data/testimonials';
import { TestimonialCard } from './TestimonialCard';
export function Testimonials() {
  return <section className="w-full bg-white py-20" data-id="element-197" data-mp="3fxb2uio71qc6">
      <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-198" data-mp="3azjc3rzaca9k">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-199" data-mp="3ayqat6j3icyt">Lo que dicen mis pacientes</h2>
        <p className="mt-3 flex items-center justify-center gap-2 text-base text-gray-500" data-id="element-200" data-mp="31zd1cduz1oe3">
          <span className="flex text-amber" data-id="element-201" data-mp="2x0jqyuazedi5">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber" aria-hidden="true" data-id="element-202" data-mp="2s28d88hkfiun" data-mpi={i} />)}
          </span>
          4.9/5 · Más de 3.000 descargas verificadas
        </p>

        <div className="mt-14 grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-203" data-mp="qac393b1qh1z">
          {testimoniosDestacados.map((testimonial, index) => <motion.div key={testimonial.nombre} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-204" data-mp="h55a40zwdtwk" data-mpi={index}>
              <TestimonialCard testimonial={testimonial} data-id="element-205" data-mp="c8y282nxy8bz" />
            </motion.div>)}
        </div>
      </div>

      <div className="mt-14 border-t border-gray-100 pt-10" data-id="element-206" data-mp="14vj1rqeklqqm">
        <p className="mb-6 text-center text-sm font-medium uppercase tracking-wide text-gray-400" data-id="element-207" data-mp="14uzhi31g6q9f">Y más pacientes felices</p>
        <div className="flex snap-x snap-mandatory gap-5 overflow-x-auto px-6 pb-1 [&::-webkit-scrollbar]:hidden" style={{
        scrollbarWidth: 'none'
      }} data-id="element-208" data-mp="q4sacjgw4to1">
          {testimoniosExtra.map(testimonial => <div key={testimonial.nombre} className="flex w-[280px] shrink-0 snap-start flex-col rounded-xl border border-gray-200 bg-gray-50 p-5" data-id="element-209" data-mp="1nmjx84ghf45f">
              <div className="flex text-amber" data-id="element-210" data-mp="1sj5xvpgxl95k">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber" aria-hidden="true" data-id="element-211" data-mp="1ogjb42z4aef8" data-mpi={i} />)}
              </div>
              <p className="mt-2 text-sm italic leading-relaxed text-gray-700" data-id="element-212" data-mp="1jhpw2646mfcy">“{testimonial.texto}”</p>
              <p className="mt-3 text-xs font-bold text-mint-dark" data-id="element-213" data-mp="1ekpnnojv10io">
                {testimonial.nombre} | {testimonial.edad} años | {testimonial.ciudad}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}